import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#e5173f',
    },
    secondary: {
      main: '#fdb813',
    },
  },
});

export default theme;
